import { render } from "./opTableLocal.vue?vue&type=template&id=13a2c9e8&ts=true"
import script from "./opTableLocal.vue?vue&type=script&lang=ts"
export * from "./opTableLocal.vue?vue&type=script&lang=ts"

import "./opTableLocal.vue?vue&type=style&index=0&id=13a2c9e8&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__